import * as React from 'react';
import { mount } from 'enzyme';
import Footer from './Footer';

describe('Footer', () => {
  it('shallow renders without crashing', () => {
    const component = mount(<Footer />);

    expect(component.exists()).toBe(true);
  });

});
